import React from "react";
import { useBrand } from "../../utils/useBrand";
import { XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { isAstriaDomain } from "../../utils/branding";

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();
  const brand = useBrand();

  return (
    <div className="min-h-screen bg-[#F6EBDD] text-[#2D1B44]">
      <div className="relative mx-auto flex min-h-screen max-w-4xl items-center justify-center px-6 py-16">
        <div className="pointer-events-none absolute -left-16 top-10 h-64 w-64 rounded-full bg-[#F6B9D8] blur-3xl opacity-70" />
        <div className="pointer-events-none absolute -bottom-20 -right-20 h-72 w-72 rounded-full bg-[#A9B9FF] blur-3xl opacity-60" />
        <div className="pointer-events-none absolute right-10 top-24 h-56 w-56 rounded-full bg-[#B7F2FF] blur-3xl opacity-50" />

        <div className="relative w-full max-w-2xl overflow-hidden rounded-[32px] border border-white/60 bg-white/75 p-10 text-center shadow-[0_24px_60px_rgba(45,27,68,0.16)] backdrop-blur">
          <div className="flex flex-col items-center gap-2">
            <img
              src={isAstriaDomain() ? "/logo_2.png" : "/healjai-chat-logo.png"}
              alt={isAstriaDomain() ? brand.name : "HealJai"}
              className="h-14 w-auto object-contain"
            />
            <span className="text-sm font-semibold uppercase tracking-[0.4em] text-[#6D4C92]">
              {isAstriaDomain() ? brand.name : "HealJai"}
            </span>
          </div>
          <div className="mx-auto mt-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#F2E7FF]">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#2D1B44] text-[#F6EBDD] shadow-lg">
              <XCircle className="h-8 w-8" />
            </div>
          </div>
          <h1 className="mt-6 font-['Fraunces'] text-4xl font-semibold">
            ยกเลิกการชำระเงินแล้ว
          </h1>
          <p className="mt-3 font-['Manrope'] text-base text-[#2D1B44]/70">
            ไม่เป็นไร การชำระเงินของคุณถูกยกเลิกและไม่มีการเรียกเก็บเงิน
          </p>
          <div className="mt-8 rounded-2xl border border-[#2D1B44]/10 bg-[#F6EBDD] p-5 text-left text-sm text-[#2D1B44]/70">
            หากคุณเพียงแค่ลองดู คุณสามารถกลับมาได้ทุกเมื่อ Your
            cart is saved with the same plan selection.
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <button
              onClick={() =>
                navigate(isAstriaDomain() ? "/journey" : "/subscription")
              }
              className="rounded-full bg-[#2D1B44] px-5 py-2 text-sm font-semibold text-[#F6EBDD] transition hover:shadow-lg"
            >
              {isAstriaDomain() ? "กลับไปที่การเดินทาง" : "กลับไปที่แพ็กเกจ"}
            </button>
            <button
              onClick={() => navigate("/")}
              className="rounded-full border border-[#2D1B44]/20 px-5 py-2 text-sm font-semibold text-[#2D1B44] transition hover:border-[#2D1B44]/40"
            >
              ไปที่หน้าหลัก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
